import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialClosedFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ClosedFilterData from "./ClosedFilterData";



const ClosedFilter = ({ filterData, onSetFilterData, onCallApiAgain, from }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialClosedFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleFilterChange = (value, name) => {
    onSetFilterData({ ...filterData, [name]: value });
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      property_name: value?.property_name,
      created_at: value?.created_at,
      created_start_date: value?.created_start_date,
      created_end_date: value?.created_end_date,
      min_contract_cap_rate: value?.min_contract_cap_rate,
      max_contract_cap_rate: value?.max_contract_cap_rate,
      min_contract_price: value?.min_contract_price,
      max_contract_price: value?.max_contract_price,
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  const saveSearchFilterData = {
    property_name: filterData?.property_name,
    created_at: filterData?.created_at,
    created_start_date: filterData?.created_start_date,
    created_end_date: filterData?.created_end_date,
    min_contract_cap_rate: filterData?.min_contract_cap_rate,
    max_contract_cap_rate: filterData?.max_contract_cap_rate,
    min_contract_price: filterData?.min_contract_price,
    max_contract_price: filterData?.max_contract_price,

  };

  return (
    <div>
      <SavedFilterComponent
        from={from}
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialClosedFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          onSetFilterData(initialClosedFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        from={from}
        desc={`Enter ${from} information.`}
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <ClosedFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default ClosedFilter;
